export const PROFILE_ROLE_OPTIONS = [
  { value: "landowner", label: "Landowner / Land Share" },
  { value: "farmer", label: "Farmer / Grower" },
  { value: "homesteader", label: "Homesteader" },
  { value: "day_worker", label: "Farm Worker" },
  { value: "community", label: "Community Member" },
  { value: "event_planner", label: "Event Planner" },
  { value: "local_supporter", label: "Local Supporter" },
  { value: "rancher_livestock", label: "Rancher / Livestock" },
  { value: "farm_stand_owner", label: "Farm Stand Owner" },
  { value: "pickup_spot_owner", label: "Porch Pickup / Pickup Spot Owner" },
  { value: "baker_cottage_food", label: "Baker / Cottage Food" },
  { value: "maker_artisan", label: "Maker / Artisan" },
  { value: "gardener_plant_seller", label: "Gardener / Plant Seller" },
  { value: "local_business", label: "Local Business" },
  { value: "service_provider", label: "Service Provider" },
];

export const ADDITIONAL_PROFILE_ROLE_OPTIONS = PROFILE_ROLE_OPTIONS.slice(6);

export const PROFILE_ROLE_LABELS = Object.freeze(
  PROFILE_ROLE_OPTIONS.reduce((labels, option) => {
    labels[option.value] = option.label;
    return labels;
  }, {})
);

export const SYSTEM_ROLE_VALUES = [
  "farmer",
  "landowner",
  "homesteader",
  "day_worker",
  "community",
  "event_planner",
];

export const getProfileRoleLabel = (role) => {
  const value = String(role || "");
  return PROFILE_ROLE_LABELS[value] || value.replace(/_/g, " ");
};

export const toggleProfileRole = (roles, roleValue, checked) => {
  const currentRoles = Array.isArray(roles) ? roles : [];

  if (checked) {
    return currentRoles.includes(roleValue)
      ? currentRoles
      : [...currentRoles, roleValue];
  }

  return currentRoles.filter((role) => role !== roleValue);
};

export const normalizeStoredProfileRoles = (roles) => {
  if (!Array.isArray(roles)) return [];

  return [...new Set(roles.filter((role) => typeof role === "string" && role.length > 0))];
};

export const getPreservedSystemRole = ({
  existingRole,
  existingType,
  selectedRoles = [],
} = {}) => {
  if (typeof existingRole === "string" && existingRole.length > 0) {
    return existingRole;
  }

  if (typeof existingType === "string" && existingType.length > 0) {
    return existingType;
  }

  return (
    selectedRoles.find((role) => SYSTEM_ROLE_VALUES.includes(role)) ||
    "farmer"
  );
};
